var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListNumbered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Numbered list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Numbered-list",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.000000, 6.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.1666667,
    y1: 1.66666667,
    x2: 6.16666667,
    y2: 1.66666667,
    id: "f4028e8e-8446-41a2-8b39-5516135d53c3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.1666667,
    y1: 10.3333333,
    x2: 6.16666667,
    y2: 10.3333333,
    id: "28d13287-8f94-40ff-8472-6e40f4c13538"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.1666667,
    y1: 19,
    x2: 6.16666667,
    y2: 19,
    id: "c61ad2fd-4810-48f8-b1ef-3bda8ada6063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.778333333,18.245 C0.870065922,18.227377 0.963256681,18.2184485 1.05666667,18.2183333 C1.76166667,18.2183333 2.33333333,18.7083333 2.33333333,19.3116667 C2.33333333,19.915 1.76166667,20.4783333 1.05666667,20.4783333 C0.624737311,20.489835 0.220420457,20.2666316 3.02424752e-13,19.895",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "8.50430837e-14 16.8333333 2.18833333 16.8333333 0.775 18.245"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "0.166666667 0.916666667 1.5 -3.77475828e-14 1.5 3.58333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83333333,10.1833333 C2.04594224,10.0270186 2.17351019,9.78051051 2.17833333,9.51666667 C2.17833333,9.01666667 1.70833333,8.55666667 1.12833333,8.55666667 C0.772792356,8.54724865 0.439966467,8.73087672 0.258333333,9.03666667",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333333,12.1666667 L0.166666644,12.1666667 C0.166600066,11.8224123 0.316242628,11.4951452 0.576666667,11.27 L1.84833333,10.1666667",
    id: "Path",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumbered);
export default __webpack_public_path__ + "static/media/list-numbered.2886867c452ad99c92539156f08b8fd6.svg";
export { ForwardRef as ReactComponent };